import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import Loading from '../Shared/Loading';

const SingleProject = () => {

    const Id = useParams();

    const { data: singleProject, isLoading, refetch } = useQuery('singleP', () =>
        fetch(`https://stark-wildwood-35883.herokuapp.com/projects/${Id.Id}`)
            .then(res => res.json())
    );
    refetch();

    if (isLoading) {
        return <Loading />
    }

    const { name, coverImg, img1, img2, img3, title, url, clientSide, serverSide, point1, point2, point3, point4, point5, userd, des } = singleProject;


    return (
        <div className='lg:px-20 md:px-10 mt-5'>
            <h2 className='mb-2 text-2xl text-green-500 text-start uppercase font-bold py-3 md:px-0 px-9'>Project <span className='text-primary'>ScreenShort</span></h2>
            <div className='grid  gap-10 lg:grid-cols-3 md:grid-cols-2 grid-cols-1'>
                <div className='custom_shadow md:w-full  w-5/6 mx-auto overflow-hidden border-2 border-primary rounded-lg'>
                    <img src={img1} className="  hover:scale-105  duration-150  " alt="Project_Img1 " />
                </div>
                <div className='custom_shadow md:w-full  w-5/6 mx-auto  overflow-hidden border-2 border-primary rounded-lg'>
                    <img src={img2} className=" hover:scale-105  duration-150 " alt="Project_Img2 " />
                </div>
                <div className='custom_shadow md:w-full  w-5/6 mx-auto  overflow-hidden border-2 border-primary rounded-lg'>
                    <img src={img3} className=" hover:scale-105  duration-150 " alt="Project_Img3 " />
                </div>
            </div>
            <div className='mt-6'>
                <div className='grid gap-10 lg:grid-cols-2 md:grid-cols-2 grid-cols-1'>
                    <div className='mb-10' >
                        <h2 className='text-2xl text-green-500 text-start uppercase font-bold py-3 md:px-0 px-9'>Project <span className='text-primary'>Details</span></h2>
                        <div className='md:w-full w-5/6 mx-auto'>
                            <h2 className='text-xl font-bold'>Project Name: <a href={url} target="_blank" rel="noopener noreferrer"> <span className='text-indigo-600'> {name}</span></a> </h2>
                            <h2 className='text-md font-semibold text-green-500'>{title}</h2>
                            <ul className='ml-6 mt-2 pr-2 mb-3'>
                                {point1 && <li className='list-disc text-gray-500  text-lg '>{point1}</li>}
                                {point2 && <li className='list-disc text-gray-500  text-lg'>{point2}</li>}
                                {point3 && <li className='list-disc text-gray-500 text-lg '>{point3}</li>}
                                {point4 && <li className='list-disc text-gray-500 text-lg '>{point4}</li>}
                                {point5 && <li className='list-disc text-gray-500 text-lg '>{point5}</li>}
                                {userd && <li className='list-disc text-gray-500 text-lg '>Technologies Used : {userd}</li>}
                            </ul>
                            {des && <h3 className='text-lg text-gray-500'>{des}</h3>}
                        </div>
                    </div>
                    <div className='mb-6'>
                        <h2 className='text-2xl mb-4 text-green-500 text-start uppercase font-bold py-3 md:px-0 px-9'>Project <span className='text-primary'>Resource</span></h2>
                        <div className='md:w-full w-5/6 mx-auto'>
                            <div className='custom_shadow rounded-xl'>
                                {coverImg && <img src={coverImg} className="mb-4 rounded-tr-xl rounded-tl-xl " alt="" />}
                                <div className='p-4'>
                                    <h2 className='text-xl font-bold text-green-500 pb-2'> <span className='text-indigo-700 font-bold'>{name} </span> Links</h2>
                                    <div className='grid lg:grid-cols-3 mb-2  md:grid-cols-2 grid-cols-1'>
                                        <h2><span> <button className='btn bg-green-500 border-0 text-white'><a href={url} target="_blank" rel="noopener noreferrer"> LIVE PROJECT </a> </button> </span> </h2>
                                        {clientSide ? <h2><span> <button className='btn bg-green-500 border-0 text-white'> <a href={clientSide} target="_blank" rel="noopener noreferrer"> CLIENT SIDE CODE  <FontAwesomeIcon className='ml-1'  icon={faArrowUpRightFromSquare} /> </a>  </button> </span> </h2> : ""}
                                        {serverSide ? <h2><span> <button className='btn bg-green-500 border-0 text-white' > <a href={serverSide} target="_blank" rel="noopener noreferrer"> SERVER SIDE CODE  <FontAwesomeIcon  className='ml-1' icon={faArrowUpRightFromSquare} /></a></button> </span> </h2> : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleProject;